var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "balance-exchange-rate" },
    [
      _c("h2", { staticClass: "section-title" }, [
        _vm._v(_vm._s(_vm.$t("dashboard.my_assets"))),
      ]),
      _c(
        "div",
        {
          ref: "balanceCard",
          staticClass: "balance-card",
          class: {
            "balance-card--compact": _vm.defaultVisibleCount === 4,
            "balance-card--three-columns": _vm.defaultVisibleCount === 3,
          },
        },
        [
          _c(
            "el-skeleton",
            {
              staticStyle: { width: "100%" },
              attrs: { loading: _vm.loading, animated: "" },
            },
            [
              _c("div", [
                _c(
                  "div",
                  { staticClass: "balance-card__header" },
                  [
                    _c("div", [
                      _c("h3", { staticClass: "card-title" }, [
                        _vm._v(_vm._s(_vm.$t("dashboard.account_balance"))),
                      ]),
                      _c("div", { staticClass: "total-balance" }, [
                        _c("span", { staticClass: "total-balance__amount" }, [
                          _vm._v(
                            "≈ " +
                              _vm._s(
                                _vm._f("toDivideWithDot")(_vm.totalBalance)
                              )
                          ),
                        ]),
                        _c("span", { staticClass: "total-balance__currency" }, [
                          _vm._v("USD"),
                        ]),
                      ]),
                      _c("p", { staticClass: "card-tip" }, [
                        _vm._v(
                          _vm._s(_vm.$t("dashboard.balance_exchange_rate_tip"))
                        ),
                      ]),
                    ]),
                    _vm.$store.getters.authorities.includes("AUTH_CODE_BALANCE")
                      ? _c(
                          "el-button",
                          {
                            staticClass: "withdraw-button",
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.$refs.withdrawModalRef.changModalStatus(
                                  true
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("dashboard.withdraw_now")) +
                                " "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "currency-list" },
                  _vm._l(_vm.visibleBalances, function (item) {
                    return _c(
                      "div",
                      { key: item.currency, staticClass: "currency-item" },
                      [
                        _c("img", {
                          staticClass: "currency-item__flag",
                          attrs: {
                            src: item.flag,
                            alt: "",
                            "aria-hidden": "true",
                          },
                        }),
                        _c("span", { staticClass: "currency-item__code" }, [
                          _vm._v(_vm._s(item.currency)),
                        ]),
                        _c("span", { staticClass: "currency-item__amount" }, [
                          _vm._v(
                            _vm._s(_vm._f("toDivideWithDot")(item.amount))
                          ),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
                _vm.balances.length > _vm.defaultVisibleCount
                  ? _c(
                      "button",
                      {
                        staticClass: "expand-button",
                        attrs: {
                          type: "button",
                          "aria-expanded": _vm.expanded,
                        },
                        on: {
                          click: function ($event) {
                            _vm.expanded = !_vm.expanded
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.expanded
                                ? _vm.$t("dashboard.collapse")
                                : _vm.$t("dashboard.expand_more")
                            ) +
                            " "
                        ),
                        _c("i", {
                          class: _vm.expanded
                            ? "el-icon-arrow-up"
                            : "el-icon-arrow-down",
                        }),
                      ]
                    )
                  : _vm._e(),
              ]),
            ]
          ),
        ],
        1
      ),
      _c("h2", { staticClass: "section-title exchange-title" }, [
        _vm._v(_vm._s(_vm.$t("dashboard.reference_exchange_rate"))),
      ]),
      _c("div", { staticClass: "exchange-card" }, [
        _c(
          "div",
          { staticClass: "exchange-row" },
          [
            _c(
              "el-input",
              {
                staticClass: "amount-input",
                on: { input: _vm.handleSourceInput },
                model: {
                  value: _vm.sourceAmount,
                  callback: function ($$v) {
                    _vm.sourceAmount = $$v
                  },
                  expression: "sourceAmount",
                },
              },
              [
                _c(
                  "el-select",
                  {
                    staticClass: "currency-select",
                    attrs: { slot: "append", disabled: "" },
                    slot: "append",
                    model: {
                      value: _vm.sourceCurrency,
                      callback: function ($$v) {
                        _vm.sourceCurrency = $$v
                      },
                      expression: "sourceCurrency",
                    },
                  },
                  _vm._l(_vm.sourceCurrencyOptions, function (item) {
                    return _c(
                      "el-option",
                      { key: item.value, attrs: { value: item.value } },
                      [
                        _c("span", { staticClass: "select-option" }, [
                          _c("img", {
                            staticClass: "select-option__flag",
                            attrs: { src: item.flag, alt: "" },
                          }),
                          _vm._v(" " + _vm._s(item.value) + " "),
                        ]),
                      ]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "button",
              {
                staticClass: "exchange-icon",
                attrs: { type: "button", tabindex: "-1" },
              },
              [_vm._v("→")]
            ),
            _c(
              "el-input",
              {
                staticClass: "amount-input",
                attrs: { readonly: "" },
                model: {
                  value: _vm.targetAmount,
                  callback: function ($$v) {
                    _vm.targetAmount = $$v
                  },
                  expression: "targetAmount",
                },
              },
              [
                _c(
                  "el-select",
                  {
                    staticClass: "currency-select",
                    attrs: { slot: "append" },
                    on: { change: _vm.handleTargetCurrencyChange },
                    slot: "append",
                    model: {
                      value: _vm.targetCurrency,
                      callback: function ($$v) {
                        _vm.targetCurrency = $$v
                      },
                      expression: "targetCurrency",
                    },
                  },
                  _vm._l(_vm.currencyOptions, function (item) {
                    return _c(
                      "el-option",
                      { key: item.value, attrs: { value: item.value } },
                      [
                        _c("span", { staticClass: "select-option" }, [
                          _c("img", {
                            staticClass: "select-option__flag",
                            attrs: { src: item.flag, alt: "" },
                          }),
                          _vm._v(" " + _vm._s(item.value) + " "),
                        ]),
                      ]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm.targetCurrency && _vm.exchangeRate
          ? _c("p", { staticClass: "rate-info" }, [
              _vm._v(
                "1 " +
                  _vm._s(_vm.sourceCurrency) +
                  " = " +
                  _vm._s(_vm.exchangeRate) +
                  " " +
                  _vm._s(_vm.targetCurrency) +
                  " · " +
                  _vm._s(_vm.$t("dashboard.updated_at")) +
                  " " +
                  _vm._s(_vm.updatedAt)
              ),
            ])
          : _vm._e(),
        _c("p", { staticClass: "rate-tip" }, [
          _vm._v(_vm._s(_vm.$t("dashboard.exchange_rate_disclaimer"))),
        ]),
      ]),
      _c("MultiMchWithdrawModal", { ref: "withdrawModalRef" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }